import React from "react";
import Selector from "../dropdown/commonDropdown/Selector";
import RadioButton from "./RadioButton";
import ValidationText from "../../utils/validation/ValidationText";
import ToggleButton from "../common/ToggleButton";
import DropdownSelect from "../dropdown/Dropdown";

const EditDetailsColumn2 = (props) => {
    return (
        <>
            <div className="text-[#757575] text-[18px]">
                <h2 className="text-[18px] text-[#757575] font-bold mb-2">
                    Entry Topic <span className="text-[#c00000]">*</span>
                </h2>
                <Selector
                    options={props.categoryEntry}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={props.handleChangeInDropdown}
                    allowSelectAll={true}
                    value={props.categoryCampaignItem.selectedCategoryEntryIds}
                    drpIdentity="CategoryEntry"
                />
                <div>
                    <ValidationText
                        error={props.validState.error.selectedCategoryEntryIds}
                    />
                </div>
            </div>

            <div className="text-[#757575] text-[18px] ">
                <h2 className="font-bold mb-2">
                    Campaign <span className="text-[#c00000]">*</span>
                </h2>
                <Selector
                    options={props.campaignList}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    onChange={props.handleChangeInDropdown}
                    allowSelectAll={false}
                    value={props.campaignList.find(
                        (item) =>
                            item.value === props.categoryCampaignItem.selectedCampaignId
                    )}
                    drpIdentity="CampaignName"
                />
                <div>
                    <ValidationText
                        error={props.validState.error.selectedCampaignId}
                    />
                </div>
            </div>

            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">Meta Title</h2>
                <input
                    className="w-full"
                    placeholder=""
                    type="text"
                    name="metaTitle"
                    value={props.categoryCampaignItem.metaTitle || ""}
                    onChange={(event) => props.handleChange(event)}
                />
            </div>

            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">Meta Keyword</h2>
                <input
                    className="w-full"
                    placeholder=""
                    type="text"
                    name="metaKeyword"
                    value={props.categoryCampaignItem.metaKeyword || ""}
                    onChange={(event) => props.handleChange(event)}
                />
            </div>

            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                    Meta Description <span className="text-[#c00000]">*</span>
                </h2>
                <textarea
                    className="w-full h-[120px]"
                    placeholder=""
                    name="metaDescription"
                    rows="2"
                    value={props.categoryCampaignItem.metaDescription || ""}
                    onChange={(event) => props.handleChange(event)}
                    onBlur={() => props.validateField("metaDescription")}
                />
                <div>
                    <ValidationText
                        error={props.validState.error.metaDescription}
                    />
                </div>
            </div>

            <div className="text-[#757575] text-[18px]">
                <ToggleButton
                    label="Featured"
                    setToggle={props.categoryCampaignItem.isFeatured}
                    onHandleToggle={props.filterByFeatured}
                    index={0}
                    identity="Featured"
                />
            </div>

            <div className="text-[#757575] text-[18px]">
                <ToggleButton
                    label="Reminder Email"
                    setToggle={props.categoryCampaignItem.isReminderEmail}
                    onHandleToggle={props.filterByFeatured}
                    index={1}
                    identity="ReminderEmail"
                />
            </div>

            <div className="text-[#757575] text-xl">Visibility</div>

            <div>
                <RadioButton
                    radioLabel="Hidden"
                    name="visibility-radio"
                    id="isHidden"
                    value={props.categoryCampaignItem.isHidden}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isHidden === true}
                />
            </div>

            <div>
                <RadioButton
                    radioLabel="Private"
                    name="visibility-radio"
                    id="isPrivate"
                    value={props.categoryCampaignItem.isPrivate}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isPrivate === true}
                />
            </div>

            <div>
                <RadioButton
                    radioLabel="Public"
                    name="visibility-radio"
                    id="isPublic"
                    value={props.categoryCampaignItem.isPublic}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isPublic === true}
                />
            </div>

            <div className="text-[#757575] text-[18px] ">
                <h2 className="font-bold mb-2">
                    Division Code <span className="text-[#c00000]">*</span>
                </h2>
                <DropdownSelect
                    drpIdentity={"financeDivisionCodes"}
                    optionArray={props.financeDivisionCodes}
                    value={props.categoryCampaignItem.financeDivisionCodeId != null ? props.categoryCampaignItem.financeDivisionCodeId : 0}
                    setFilterParameters={props.handleChangeInCodesDropdown}
                    onBlur={(e) => props.validate("financeDivisionCodeId", props.categoryCampaignItem)}
                />
                <div>
                    <ValidationText
                        error={props.validState.error.financeDivisionCodeId}
                    />
                </div>
            </div>

            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                    Event ID <span className="text-[#c00000]">*</span>
                </h2>
                <input
                    className="w-full"
                    type="text"
                    name="eventIDName"
                    value={props.categoryCampaignItem.eventIDName || ""}
                    onChange={(event) => props.handleChange(event)}
                    onBlur={() => props.validateField("eventIDName")}
                />
                <div>
                    <ValidationText error={props.validState.error.eventIDName} />
                </div>
            </div>
        </>
    );
};

export default EditDetailsColumn2;
